export function externalLink() {
 function ready(fn) {
  if (document.readyState !== "loading") {
   fn();
  } else if (document.addEventListener) {
   document.addEventListener("DOMContentLoaded", fn);
  } else {
   document.attachEvent("onreadystatechange", function () {
    if (document.readyState !== "loading") fn();
   });
  }
 }

 ready(function () {
  const internalLinkRegex = /^((((http:\/\/|https:\/\/)(www\.)?)?localhost:\d{4})|(\/.*))(\/.*)?$/;

  const anchorEls = document.querySelectorAll(".fuwaraku a:not(.p-anchor):not(.p-manual-external-link)");
  const anchorElsLength = anchorEls.length;

  for (let i = 0; i < anchorElsLength; i++) {
   const anchorEl = anchorEls[i];
   const href = anchorEl.getAttribute("href");

   if (!internalLinkRegex.test(href)) {
    anchorEl.setAttribute("target", "_blank");
    anchorEl.setAttribute("rel", "noopener");
    // リファラー情報は送信されます
   }
  }
 });
}
